import React, { useState, useMemo, useEffect, useContext } from "react";
import { Link, useHistory } from "react-router-dom";
import api from "../../services/config.url";
import { IoIosAlert } from "react-icons/io";
import { FaCrown, FaDownload } from "react-icons/fa";
import showPopup from "../PopUp";
import bookModel from "./../../assets/images/books/grid/imageNotFound.jpg";
import AuthContext from "../../contexts/auth";
import { downloadMateria } from "../../services/downloadPdf";

export default function RecomendedSlider({ search }) {
  const history = useHistory();
  const { user, setLoading } = useContext(AuthContext);
  const isPremium = !!(
    user?.subscriptionExpiresAt && new Date(user.subscriptionExpiresAt) > new Date()
  );
  const urlRoute = search ? `search=${search}` : `parent=null`;
  const [products, setProducts] = useState([]);
  const [isLoadingContainer, setIsLoadingContainer] = useState(false);

  useEffect(() => {
    setIsLoadingContainer(true);
    api
      .get(`/customers/products?current=1&pageSize=1000&${urlRoute}`)
      .then((response) => {
        setProducts(response.data.records);
      })
      .catch((error) => {
        // const genericError =
        //   "Sua barra de pesquisa não localizou nenhum produto.";
        // showPopup(error?.response?.data?.message || genericError, "error");
      })
      .finally(() => {
        setIsLoadingContainer(false);
      });
  }, [search]);

  const itemsToShow = useMemo(() => {
    return (
      products
        // .filter((book) => book.amount !== 0)
        .map((book, index) => {
          const amount = book.amount || 0;
          const integerPart = Math.floor(amount);
          const decimalPart = String(Math.round((amount % 1) * 100)).padStart(
            2,
            "0"
          );

          return (
            <div
              className="premium-book-card"
              key={index}
              onClick={() => history.push(`/livro-detalhes/${book.slug}`)}
            >
              <Link
                to={`livro-detalhes/${book.slug}`}
                className="premium-card-cover"
                onClick={(e) => e.stopPropagation()}
              >
                <img
                  src={
                    (book.photos &&
                      book.photos[0] &&
                      book.photos[0].photo &&
                      book.photos[0].photo.url) ||
                    bookModel
                  }
                  alt={book.name}
                />
              </Link>
              <div className="premium-card-body">
                <Link
                  to={`livro-detalhes/${book.slug}`}
                  className="premium-card-title-link"
                  onClick={(e) => e.stopPropagation()}
                >
                  <h3 className="premium-card-title">{book.name}</h3>
                </Link>
                {isPremium ? (
                  // Premium: sem preço, só o botão de download da matéria.
                  <button
                    type="button"
                    className="premium-card-cta premium-card-cta-download"
                    onClick={(e) => {
                      e.stopPropagation();
                      downloadMateria(book, user, setLoading);
                    }}
                  >
                    <FaDownload className="premium-card-cta-icon" />
                    Download
                  </button>
                ) : (
                  <>
                    <span className="premium-card-price-label">
                      Caderno avulso:
                    </span>
                    <div className="premium-card-price">
                      <span className="premium-card-price-currency">R$</span>
                      <span className="premium-card-price-integer">
                        {integerPart}
                      </span>
                      <span className="premium-card-price-decimal">
                        ,{decimalPart}
                      </span>
                    </div>
                    <Link
                      to="/planoanual"
                      className="premium-card-cta premium-card-cta-wrap"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <FaCrown className="premium-card-cta-icon" />
                      Assine o Plano Anual e tenha acesso ilimitado a todos
                      os Cadernos.
                    </Link>
                  </>
                )}
              </div>
            </div>
          );
        })
    );
  }, [products, isPremium]);

  return (
    <>
      {isLoadingContainer ? (
        <div className="loadingContainer"></div>
      ) : (
        <>
          <section className="container box-main">
            <div>
              {itemsToShow?.length ? (
                <div className="row grid">{itemsToShow}</div>
              ) : (
                <p className="text-center ">
                  <IoIosAlert size={50} /> {" Ops! Nenhum produto encontrado."}
                </p>
              )}
            </div>
          </section>
        </>
      )}
    </>
  );
}
